
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/muses/interviews",
      function () {
        return require("private-next-pages/muses/interviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/muses/interviews"])
      });
    }
  